/**
 * The human body plan — AoD §3.1's parts, unchanged.
 *
 * Fourteen of them, not the thirteen §3.1's prose claims: its own table
 * enumerates head, two eyes, neck, chest, abdomen, two arms, two hands, two
 * legs and two feet, which is fourteen. The list is what was designed and the
 * count was a slip, so the list is what ported.
 *
 * Enough resolution that wounds are specific and consequences differ; few
 * enough parts that the log stays readable and the tables stay affordable.
 * Every capability's shares sum to 1, so an uninjured body sits at exactly
 * 1.0 across the board and the validator will say so if that ever drifts.
 */
export const HUMAN_PLAN = {
    id: 'human',
    name: 'human',
    parts: [
        {
            id: 'head',
            zone: 'head',
            side: null,
            name: 'head',
            hitWeight: 1,
            contributes: { consciousness: 0.75 },
            contains: ['skull', 'brain', 'jaw'],
            vital: true,
        },
        {
            id: 'eye.left',
            zone: 'eye',
            side: 'left',
            name: 'left eye',
            hitWeight: 1,
            contributes: { sight: 0.5 },
            contains: ['eye'],
        },
        {
            id: 'eye.right',
            zone: 'eye',
            side: 'right',
            name: 'right eye',
            hitWeight: 1,
            contributes: { sight: 0.5 },
            contains: ['eye'],
        },
        {
            id: 'neck',
            zone: 'neck',
            side: null,
            name: 'neck',
            hitWeight: 1,
            // Rare location, extremely lethal: the great vessels and the windpipe
            // are within a finger's breadth of the skin.
            contributes: { consciousness: 0.25, breath: 0.2 },
            contains: ['artery', 'windpipe', 'spine'],
            vital: true,
        },
        {
            id: 'chest',
            zone: 'chest',
            side: null,
            name: 'chest',
            hitWeight: 1,
            contributes: { breath: 0.6 },
            contains: ['rib', 'lung', 'heart'],
            vital: true,
        },
        {
            id: 'abdomen',
            zone: 'abdomen',
            side: null,
            name: 'belly',
            hitWeight: 1,
            contributes: { breath: 0.2 },
            contains: ['gut', 'liver'],
            vital: true,
        },
        {
            id: 'arm.left',
            zone: 'arm',
            side: 'left',
            name: 'left arm',
            hitWeight: 1,
            contributes: { gripL: 0.4 },
            contains: ['bone', 'muscle'],
        },
        {
            id: 'arm.right',
            zone: 'arm',
            side: 'right',
            name: 'right arm',
            hitWeight: 1,
            contributes: { gripR: 0.4 },
            contains: ['bone', 'muscle'],
        },
        {
            id: 'hand.left',
            zone: 'hand',
            side: 'left',
            name: 'left hand',
            hitWeight: 1,
            contributes: { gripL: 0.6 },
            contains: ['bone', 'tendon'],
        },
        {
            id: 'hand.right',
            zone: 'hand',
            side: 'right',
            name: 'right hand',
            hitWeight: 1,
            contributes: { gripR: 0.6 },
            contains: ['bone', 'tendon'],
        },
        {
            id: 'leg.left',
            zone: 'leg',
            side: 'left',
            name: 'left leg',
            hitWeight: 1,
            contributes: { mobility: 0.3 },
            contains: ['bone', 'muscle', 'joint'],
        },
        {
            id: 'leg.right',
            zone: 'leg',
            side: 'right',
            name: 'right leg',
            hitWeight: 1,
            contributes: { mobility: 0.3 },
            contains: ['bone', 'muscle', 'joint'],
        },
        {
            id: 'foot.left',
            zone: 'foot',
            side: 'left',
            name: 'left foot',
            hitWeight: 1,
            contributes: { mobility: 0.2 },
            contains: ['bone', 'tendon'],
        },
        {
            id: 'foot.right',
            zone: 'foot',
            side: 'right',
            name: 'right foot',
            hitWeight: 1,
            contributes: { mobility: 0.2 },
            contains: ['bone', 'tendon'],
        },
    ],
};
//# sourceMappingURL=human.js.map